module.exports = __webpack_public_path__ + "static/media/4.76f327ce.JPG";